export enum CustomerEditorTabId {
    Details = 'details',
    ApiAllocation = 'apiAllocation',
    AssignFeatures = 'assignFeatures',
    AssignUsers = 'assignUsers',
    Locations = 'locations',
    RainfallProfile = 'rainfallProfile',
    Gis = 'gis',
    FtpSweep = 'ftpSweep',
}

export interface CustomerEditorPaginationState {
    length: number;
    pageIndex: number;
    pageSize: number;
    pageSizeOptions: number[];
}
